var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.795898,
    y: 0.17749,
    width: 42,
    height: 42,
    rx: 12,
    fill: "#4C4E7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7959 24.7299C28.6222 28.4668 25.131 31.1775 21.0067 31.1775C15.9197 31.1775 11.7959 27.0537 11.7959 21.9667C11.7959 17.8424 14.5065 14.3512 18.2435 13.1775",
    stroke: "#FEFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.709 19.1248C30.6474 15.3219 27.6515 12.3259 23.8486 11.2644C22.205 10.8056 20.7959 12.2317 20.7959 13.9381V20.6326C20.7959 21.4858 21.4876 22.1775 22.3408 22.1775H29.0353C30.7417 22.1775 32.1678 20.7684 31.709 19.1248Z",
    stroke: "#FEFEFE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallment);
export default __webpack_public_path__ + "static/media/Installment.0ec7bbc53d9d27d5426573a24b8fc8ab.svg";
export { ForwardRef as ReactComponent };